// extracted by mini-css-extract-plugin
export default {"container":"SetupNotifications_container__JT12Z","row":"SetupNotifications_row__z5cpp"};